export const SupportTitle: React.FC = () => {
  return (
    <div className="font-size-14">
      Welcome to help center! Here are some videos to answer to your questions. Can’t find what you’re looking for? Send
      our support team a note at
      <a className="pl-6" href="mailto:helpnvision@nvisionglobal.com">
        helpnvision@nvisionglobal.com
      </a>
    </div>
  );
};
